import * as Types from '../types'

export default
{
	state:
	{
		no_permission: false,
	},

	mutations:
	{
        [Types.SET_NO_PERMISSION](state)
		{
            state.no_permission = true
        },

		[Types.UNSET_NO_PERMISSION](state)
		{
			state.no_permission = false
		},
	},

	actions:
	{
		[Types.SET_NO_PERMISSION]({ commit })
		{
			commit({ type: Types.SET_NO_PERMISSION })
		},

		[Types.UNSET_NO_PERMISSION]({ commit })
		{
			commit({ type: Types.UNSET_NO_PERMISSION })
		},
	},
}